document.addEventListener('DOMContentLoaded', () => {
  const CLOSE_DELAY = 50;
  const SELECTOR_DETAILS = 'details.header-menu-details';
  const SELECTOR_HEADER_ITEM = '.header__menu-item';
  const SELECTOR_MEGA_MENU = '.mega-menu__content';
  const SELECTOR_HEADER_SUBMENU = '.header__submenu';

  function attachHoverListeners(details, elements) {
    let timeoutId = null;

    const openDetails = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      details.open = true;
    };

    const closeDetails = () => {
      timeoutId = setTimeout(() => {
        details.open = false;
        timeoutId = null;
      }, CLOSE_DELAY);
    };

    elements.forEach(element => {
      element.addEventListener('mouseenter', openDetails);
      element.addEventListener('mouseleave', closeDetails);
    });
  }

  function getHoverElements(details) {
    const selectors = [
      SELECTOR_HEADER_ITEM,
      SELECTOR_MEGA_MENU,
      SELECTOR_HEADER_SUBMENU
    ];

    return selectors
      .map(selector => details.querySelector(selector))
      .filter(Boolean);
  }

  function getClickElements(details) {
    const selectors = [
      SELECTOR_HEADER_ITEM,
    ];

    return selectors
      .map(selector => details.querySelector(selector))
      .filter(Boolean);
  }

  const detailsElements = document.querySelectorAll(SELECTOR_DETAILS);
  
  detailsElements.forEach(details => {
    const hoverElements = getHoverElements(details);
    const clickElements = getClickElements(details);

    if (hoverElements.length > 0) {
      attachHoverListeners(details, hoverElements);
    }

    if (clickElements.length > 0) {
      clickElements.forEach(element => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const redirectUrl = details.dataset.redirectUrl;
          if (redirectUrl) {
            window.location.href = redirectUrl;
          }
        });
      });
    }
  });
});
